<template>
  <TheModal
    size="medium"
    @close="closeModal"
    @save="submit"
    :onlyCancel="delivery.status === 'declined'"
  >
    <ViewSelector
      :views="viewOptions"
      :value="deliveryView"
      @change="changeView"
    />

    <transition
      :name="deliveryView === 'basic' ? 'slide-left' : 'slide-right'"
      mode="out-in"
    >
      <DeliveryBasic v-if="deliveryView === 'basic'" :delivery="delivery" />
      <DeliveryRequests
        v-if="deliveryView === 'requests'"
        :delivery="delivery"
      />
    </transition>
  </TheModal>
</template>

<script>
import { mapGetters } from "vuex";
import log from "../mixins/log.js";
import ViewSelector from "@/components/shared/ViewSelector.vue";
import DeliveryBasic from "../delivery/DeliveryBasic.vue";
import DeliveryRequests from "../delivery/DeliveryRequests.vue";
import TheModal from "@/components/shared/TheModal.vue";
export default {
  mixins: [log],
  props: ["idToEdit", "type"],
  components: {
    DeliveryBasic,
    DeliveryRequests,
    TheModal,
    ViewSelector,
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  data() {
    return {
      delivery: {
        urgency: "low",
      },
      deliveryView: "basic",
      viewOptions: [
        { name: "ДАННИ ЗА ЗАЯВКАТА", icon: "O", value: "basic" },
        { name: "ЗАЯВКА ЗА МАТЕРИАЛИ", icon: "P", value: "requests" },
      ],
    };
  },
  methods: {
    changeView(newView) {
      this.deliveryView = newView;
    },
    closeModal(isEdited) {
      this.$emit("close", isEdited);
    },
    isValid() {
      if (!this.delivery.deliveryFor) {
        this.$snotify.error("Попълнете ЗАЯВКА ЗА");
        return false;
      }

      if (!this.delivery.deliveryDate) {
        this.$snotify.error("Попълнете ЗАЯВКА ЗА ДАТА");
        return false;
      }

      if (!this.delivery.location) {
        this.$snotify.error("Попълнете ОБЕКТ");
        return false;
      }

      if (
        !this.delivery.requests &&
        !(this.delivery.files ? this.delivery.files.length : false)
      ) {
        this.$snotify.error(
          "Трябва да добавите поне един материал за доставка, или да прикачите файл"
        );
        this.deliveryView = "requests";
        return false;
      }

      if (
        this.delivery.requests &&
        this.delivery.requests.some((r) => !r.name || !r.unit || !r.qty)
      ) {
        this.deliveryView = "requests";
        this.$snotify.error(
          "Всяка заявка трява да има попълнени всички полета"
        );
        return false;
      }

      return true;
    },
    async submit() {
      if (!this.isValid()) return;
      try {
        const method = this.idToEdit ? "put" : "post";

        const url = this.idToEdit
          ? `${process.env.VUE_APP_BASE_URI}/deliveries/${this.idToEdit}`
          : `${process.env.VUE_APP_BASE_URI}/deliveries`;

        const fd = new FormData();
        fd.append("data", JSON.stringify({ ...this.delivery }));

        if (this.delivery.files && this.delivery.files.length) {
          for (let f of this.delivery.files) {
            fd.append("files", f);
          }
        }

        await this.$http[method](url, fd);

        if (this.idToEdit) {
          this.newLog("editDelivery", this.delivery.deliveryFor);
        } else {
          this.newLog("newDelivery", this.delivery.deliveryFor);
        }

        this.closeModal(true);
      } catch (err) {
        console.log(err);
      }
    },
    async getDelivery() {
      try {
        const res = await this.$http.get(
          `${process.env.VUE_APP_BASE_URI}/deliveries/${this.idToEdit}`
        );

        this.delivery = res.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    if (this.idToEdit) {
      this.getDelivery();
    } else {
      this.delivery.createdBy = this.getUser;
      this.delivery.createdAt = new Date();
    }
  },
  destroyed() {},
};
</script>
